<script>
import styleHOCFactory from './utils';
export default styleHOCFactory('cta', ['dark', 'accent']);
</script>

<style module>
@import "styles/variables.css";

._cta-style {
  composes: relative fw7 ttu tc white _collision fill-green from global;
  line-height: 1.5;
  transition: background-color 0.4s ease-in-out;
  background-color: var(--ctaGray);
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 100%;
    z-index: 1;
    border-bottom: solid 1px var(--green);
    pointer-events: none;
    transition: width 0.25s ease-in-out;
  }
  &:global(.-accent) {
    color: var(--green);
  }
  &:hover,
  &:global(.-hover),
  &:global(.router-link-exact-active) {
    background-color: var(--blackDarkOverlay);
    color: var(--green);
  }
  &:hover:after,
  &:global(.-hover:after),
  &:global(.router-link-exact-active:after) {
    width: 100%;
  }
  &:disabled,
  &:global(.-disabled) {
    color: rgba(255, 255, 255, 0.5);
    fill: rgba(255, 255, 255, 0.5);
    pointer-events: none;
    &:after {
      border-color: rgba(255, 255, 255, 0.5);
    }
  }
  &:global(.-dark),
  &:global(.-accent) {
    background-color: var(--blackDarkOverlay);
  }
}
</style>
